import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'

const TejaxoERPSoftware = ({ location }) => {
  //useEffect(() => {
  //  document.title = `Best ERP Software ${location ? `in ${location}` : ''} | ERP Systems | Business Management Solutions - Tejaxo Software`;
  //  document.querySelector('meta[name="description"]').setAttribute('content', `Tejaxo Software is a High Rated Indian ERP and BI software development company, providing award-winning Enterprise Resource Planning (ERP) software, business management solutions, services and support.`);
  //  document.querySelector('meta[name="keywords"]').setAttribute('content', `Tejaxo Software, Tejaxo ERP, ERP Software, Tejaxo BI, School ERP, School Software`);
  //}, [location]);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="/theme/img/Tejaxo-Xi-760-image-cropped-new-1024x683.jpg" alt="ERP and Analytics" />
          </div>
          <div className="col-lg-6 content">
            <h1 className="elementor-heading-title elementor-size-default">Tejaxo ERP & Analytics {location ? `in ${location}` : ''}</h1>
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <h2 className="elementor-heading-title elementor-size-default">What is ERP?</h2>
            <p>
              A powerful Enterprise Resource Planning (ERP) solution is designed to help you manage key aspects of your day-to-day business operations � from financials, marketing, distribution, supply chain, asset and facility management to manufacturing � all within one fully integrated system. This is why it�s often referred to as business management software.
              <br />
              Tejaxo Software experts take your best business processes and align them on Tejaxo Xi ERP. This way across your organisation, everyone has the same direction and information to collaborate and create one fluid system. The automation of core processes with Tejaxo Xi ERP helps your team do more, with fewer resources. Control is also maximised � strengthening your compliance with ever changing legislation and regulation.
            </p>
          </div>
          <div className="col-lg-6 content">
            <img src="/theme/img/what-is-erp-768x512.jpg" alt="ERP Concept" />
          </div>
        </div>
        <br />
        <div className="row">
          <div className="col-lg-6 about-img">
            <img src="/theme/img/analytics-768x512.jpg" alt="Analytics" />
          </div>
          <div className="col-lg-6 content">
            <h2 className="elementor-heading-title elementor-size-default">Why we combine ERP & data analytics?</h2>
            <p style={{ fontWeight: 400 }}>
              Organisations are creating an increasing volume of data, all captured in their ERP software. This data holds valuable information about opportunities and gaps. Without the right expertise, however, businesses struggle to build data models and extract these insights, especially with multiple sources of data � from the factory floor to the shop floor.
              <br />
              To enable businesses to take advantage of their data, Tejaxo Xi ERP leverages a deep integration with IBM Cognos Analytics. Relevant data is automatically pulled, depending on the query � and interactive dashboards deliver clear visualisations, customised to the needs of individual business users.
              <br />
              This is not just about populating a colourful bar chart. We believe true business intelligence is when you can ask questions and receive answers in plain language. AI-fuelled data analysis with Tejaxo Xi interprets the data, delivering actionable insights that enable confident data-led decisions � reducing your business risk and accelerating outcomes.
            </p>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};



export default TejaxoERPSoftware;
